// extracted by mini-css-extract-plugin
export default {"wrapper":"night-content_wrapper__O54qF","h2":"night-content_h2__I-MKr"};